import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants } from '..';

export function useCrmFacebookLogOut() {
  const qc = useQueryClient();

  return useMutation(
    async () => {
      const res = await $api.delete('/v1/crm/facebook/account');

      return res.data;
    },
    {
      onSuccess: async data => {
        await qc.invalidateQueries([crmConstants.queryKeys.CRM_FACEBOOK_ACCOUNT]);
        showMessage(data.message, data.accept);
      },
      onError: baseErrorHandler
    }
  );
}
